import LazyLoad from "vanilla-lazyload";

import hamburger from './lib/hamburger';

import popUp from './lib/popUp';

import acfMap from './lib/acfMap';

import stickElem from './lib/stickElem';

import filterProp from './lib/filterProp';

import customSelect from './lib/customSelect';

import resetForm from './lib/resetForm';

import tabs from './lib/tabs';

import filterPublication from './lib/filterPublication'

import formEfects from './lib/formEfects';

import addAnother from './lib/addAnother';

window.acfMap = acfMap;

window.stickElem = stickElem;

window.popUp = popUp;

window.tabs = tabs;

window.filterPublication = filterPublication;

window.filterProp = filterProp;

hamburger('.hamburger', '.header_menu');

popUp();

customSelect();

acfMap();

resetForm('#filter');

resetForm('#filter-publication');

resetForm('.wpcf7-form');

formEfects();

addAnother();

const lazyLoadInstance = new LazyLoad({
    elements_selector: ".lazy",
    load_delay: 300
});

window.lazyLoadInstance = lazyLoadInstance;